"use strict";
'use client';
exports.__esModule = true;
exports.FormControlLabel = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var text_1 = tslib_1.__importDefault(require("../text"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var FormControlLabel = function (props) {
    var className = props.className, label = props.label, children = props.children, containerRef = props.containerRef, disabled = props.disabled, textProps = props.textProps;
    return (react_1["default"].createElement("label", { className: (0, class_names_1["default"])('w-fit flex flex-row items-center gap-x-2 px-2', disabled ? 'cursor-not-allowed' : 'cursor-pointer', className), ref: containerRef },
        children,
        react_1["default"].createElement(text_1["default"], tslib_1.__assign({ type: "medium", disabled: disabled, color: "grey.700", typography: (textProps === null || textProps === void 0 ? void 0 : textProps.typography) || 'sm' }, textProps), label)));
};
exports.FormControlLabel = FormControlLabel;
exports["default"] = exports.FormControlLabel;
//# sourceMappingURL=form-control-label.js.map